"use client";

import { ClueClient, ClueClientProps } from "./ClueClient";

/**
 * Props for the ClueWrapper component.
 * Extends ClueClientProps to maintain type consistency.
 */
export type ClueWrapperProps = ClueClientProps;

/**
 * Historical wrapper around ClueClient. Previously included a nested
 * SessionProvider; removed because the root layout already mounts one and
 * the duplicate caused signIn() updates to land in only one of the two
 * provider instances, leaving consumers of the other one (like Navigation)
 * stale until a full page refresh.
 *
 * Kept as a named export for callers that already import it.
 */
export function ClueWrapper(props: ClueWrapperProps) {
  return <ClueClient {...props} />;
}
